import { Avatar, Stack, Text } from '@chakra-ui/react';
import NextLink from 'next/link';
import * as React from 'react';

import { sponsor_content_clicked } from '@/analytics';
import { Card } from '@/imports/ui/chakra/components/Card';

type IVideoDetailCardSponsorProps = {
  sponsorId: string;
  name: string;
  profileImageUrl?: string;
};

export const VideoDetailCardSponsor: React.FC<IVideoDetailCardSponsorProps> = (
  props
) => {
  return (
    <NextLink
      href={`/companies/${props.sponsorId}`}
      onClick={() => {
        sponsor_content_clicked({
          sponsor_id: props.sponsorId,
          sponsor_name: props.name,
          sponsor_content_type: 'event_sponsor_card',
          sponsor_content_id: props.sponsorId,
          sponsor_interaction_source: 'event',
          location_organization_id: props.sponsorId,
        });
      }}
    >
      <Card p="4" shadow="xs" cursor="pointer">
        <Stack direction="row" align="center" spacing="4">
          <Avatar
            size="lg"
            name={props.name}
            src={props.profileImageUrl}
            loading="lazy"
            bg={props.profileImageUrl ? 'none' : 'gray.500'}
            color="white"
          />
          <Text ml="4" textStyle="bodyStrong">
            {props.name}
          </Text>
        </Stack>
      </Card>
    </NextLink>
  );
};
